module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullheight-layout"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3497b7e9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FullHeightLayout.vue
// module id = 711
// module chunks = 1